import { render, staticRenderFns } from "./IpDetails.vue?vue&type=template&id=043da8f3&scoped=true&"
import script from "./IpDetails.vue?vue&type=script&lang=js&"
export * from "./IpDetails.vue?vue&type=script&lang=js&"
import style0 from "./IpDetails.vue?vue&type=style&index=0&id=043da8f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043da8f3",
  null
  
)

export default component.exports